import {
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
  viewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RestApiService } from './rest-api.service';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { LoaderComponent } from './main/shared/loader/loader.component';
import { filter, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './auth/service/authentication.service';
import { ApiEndpoints } from './services/api.constant';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

export interface TableElement {
  id: string;
  name: string;
  email: string;
  website: string;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService],
  imports: [RouterOutlet, LoaderComponent, ToastModule],
})
export class AppComponent implements OnInit {
  title = 'driver-app';

  private readonly restApiService = inject(RestApiService);
  private readonly translate = inject(TranslateService);
  private readonly _swUpdate = inject(SwUpdate);
  private readonly http = inject(HttpClient);
  private readonly _authenticationService = inject(AuthenticationService);

  readonly loaderComponent = viewChild.required(LoaderComponent);
  ngOnInit(): void {
    if (this._swUpdate.isEnabled) {
      this._swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
          map(evt => ({
            type: 'UPDATE_AVAILABLE',
            current: evt.currentVersion,
            available: evt.latestVersion,
          })),
        )
        .subscribe(() => {
          if (confirm('New version available. Load New Version?')) {
            window.location.reload();
          }
        });
    }
    if (this._authenticationService.currentUserValue) {
      this.GetGoogleAPIConfigurations().subscribe({
        next: configResponse => {
          this.loadGoogleMapsScript(configResponse);
        },
      });
    }
  }

  public GetConfigurations(): Observable<any> {
    return this.http.get(
      `${environment.mainapiUrl}${ApiEndpoints.ConfigurationsApi.GetAllConfigurations}`,

      //`${environment.mainapiUrl}/Configuration/GetAllConfigurations`,
    );
  }

  GetGoogleAPIConfigurations(): Observable<any> {
    let key = 'GoogleAPIkeyDriver';
    let isLocal = environment.isLocal;
    return this.http.get(
      `${environment.mainapiUrl}${ApiEndpoints.ConfigurationsApi.GetGoogleAPIConfigurations}${key}/${isLocal}`,
      //`${environment.mainapiUrl}/Configuration/GetGoogleAPIConfigurations/${key}/${isLocal}`
    );
  }

  loadGoogleMapsScript(configResponse: any) {
    const key = configResponse.googleKey;
    const script = document.createElement('script');
    script.async = true;
    script.src = configResponse.googleApiLink.replace('${key}', key);
    document.body.appendChild(script);
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }

  public isMeeting(date: Date) {
    return /10|15|20/.test(date.getDate().toString()) ? 'meeting' : '';
  }
  public isYearMeeting(date: Date) {
    return date.getMonth() % 3 ? 'meeting' : '';
  }
  public isDecadeMeeting(date: Date) {
    return date.getDate() % 2 ? 'meeting' : '';
  }
  public isCenturyMeeting(date: Date) {
    return date.getDate() % 20 ? 'meeting' : '';
  }
}
